import { EditorState } from "draft-js";

type Props = (state: EditorState) => string;

const getBlockType: Props = (state) => {
  return state.getCurrentContent().getBlockForKey(state.getSelection().getStartKey()).getType();
};

export default getBlockType;
